import React from 'react';
import classnames from 'classnames';

export default props => {
  const itemClasses = classnames('item', `epoch-${props.id}`, {
    active: props.id === props.activeItemId
  });

  return (
    <div className={itemClasses} data-id={props.id} id={`item__${props.id}`}>
      <div className="item__kicker">
        {props.milestone ? (
          <div className="item__milestone">{props.milestoneNumber}</div>
        ) : null}
        {props.kicker}
      </div>
      <div className="item__title">{props.title}</div>
      <div className="item__text">{props.text}</div>
      {props.additional && (
        <div className="item__additional">{props.additional}</div>
      )}
    </div>
  );
};
